import { useEffect, useRef, useState } from "react";
import "../css/AutocompleteInput.css";

export default function AutocompleteInput({
  name,
  value,
  onChange,
  onPlaceSelected,
  placeholder,
  country,
}) {
  const inputRef = useRef(null);
  const serviceRef = useRef(null);
  const [predictions, setPredictions] = useState([]);
  const [ready, setReady] = useState(false);
  const [inputText, setInputText] = useState(value ?? "");

  // ✅ FIX: Sync internal state with the 'value' prop
  // This is what makes the "Swap" button work!
  useEffect(() => {
    setInputText(value ?? "");
  }, [value]);

  useEffect(() => {
    if (window.google?.maps?.places) {
      serviceRef.current = new window.google.maps.places.AutocompleteService();
      setReady(true);
    }
  }, []);

  const handleChange = (e) => {
    const text = e.target.value;
    setInputText(text);

    // ✅ Crucial: Notify parent immediately as user types
    if (onChange) {
      onChange({ target: { name, value: text } });
    }

    if (!ready || !text) {
      setPredictions([]);
      return;
    }

    const request = { input: text };
    if (country) {
      request.componentRestrictions = { country };
    }

    serviceRef.current.getPlacePredictions(request, (results) => {
      setPredictions(results || []);
    });
  };

  const handleSelect = (place) => {
    const description = place.description || String(place);

    if (onPlaceSelected) {
      onPlaceSelected(place);
    }
    if (onChange) {
      onChange({ target: { name, value: description } });
    }

    setInputText(description); 
    setPredictions([]);
  };

  return (
    <div className="autocomplete">
      <input
        ref={inputRef}
        className="autocomplete-input"
        value={inputText} // Controlled by internal state
        placeholder={placeholder}
        autoComplete="off"
        onChange={handleChange}
      />
      {predictions.length > 0 && (
        <div className="autocomplete-card">
          {predictions.map((p) => (
            <div
              key={p.place_id}
              className="autocomplete-item"
              onClick={() => handleSelect(p)}
            >
              <span>{p.description}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}